<template>
    <div>
        <!-- ========== MAIN CONTENT ========== -->
    <main class="js-scroll-nav" id="content" role="main">


      <!-- Articles Section -->
      <div class="space-1 space-top-xl-1 space-bottom-lg-1">
        <!-- Title -->
        <div
          class="container w-md-80 w-lg-50 text-center mx-md-auto mb-5 mb-md-5"
        >
        <img
          src="@/assets/logo.png"
          fluid
          alt="Parceiro CAIXA"
          width="100"
          height="100"
        />
        <br>
          <span
            class="badge badge-pill badge-soft-success mt-4 p-3 small font-weight-bold mb-3"
            >Cadastro enviado com sucesso!</span
          >
          <h2 class="font-weight-light my-3">
            Seja bem vindo(a) a Plataforma Online de Financiamento Imobiliário CAIXA.
          </h2>
            <footer class="blockquote-footer">
                Estamos quase lá!<cite title="Source Title"> leia as instruções atentamente.</cite>
            </footer>
        </div>
        <!-- End Title -->

        <!-- Icon Blocks Section -->
        <div class="container space-top-1">
          <div class="row">
            

            <div class="col-md-6 mb-7">
              <!-- Icon Blocks -->
              <div class="text-center px-lg-3">
                <!--<figure class="max-w-8rem mx-auto mb-4">
                  <img
                    class="img-fluid"
                    src="@/assets/svg/icons/icon-14.svg"
                    alt="SVG"
                  />
                </figure>-->
                <h3>Valide seu e-mail</h3>
                <p>
                  Enviamos um link de verificação para o seu e-mail, clique no link e valide-o emidiatamente.
                </p>
              </div>
              <!-- End Icon Blocks -->
            </div>

            <div class="col-md-6 mb-7">
              <!-- Icon Blocks -->
              <div class="text-center px-lg-3">
                <!--<figure class="max-w-8rem mx-auto mb-4">
                  <img
                    class="img-fluid"
                    src="@/assets/svg/icons/icon-23.svg"
                    alt="SVG"
                  />
                </figure>-->
                <h3>Entraremos em contato</h3>
                <p>
                  Parabéns! Entraremos em contato para trocarmos uma ideia e liberar seu acesso ao sistema.
                </p>
              </div>
              <!-- End Icon Blocks -->
            </div>
          </div>

          <img
            class="img-fluid d-none d-md-block w-75 mx-auto mb-7"
            src="@/assets/svg/components/three-pointers.svg"
            alt="SVG Arrow"
          />
        </div>
        <!-- End Icon Blocks Section -->
      </div>
      <!-- End Articles Section -->

      <div class="d-flex justify-content-center mb-5">
        <router-link to="/login">
        <button class="btn btn-primary">
          Leve-me para página de Login
        </button>
        </router-link>
      </div>

      <!-- Google Form Section
      <div class="text-center">
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScVEBFfpw2-pcp6W-uU6b9LY6xglovXcZ4D8YOIOD5wSfJpDg/viewform?embedded=true" width="640" height="2517" frameborder="0" marginheight="0" marginwidth="0" scrolling="no">Carregando…</iframe>
        </div> -->
      <!-- End Google Form Section -->
    </main>
    <!-- ========== END MAIN CONTENT ========== -->
        
    </div>
</template>
<script>
export default {
    name: 'Sucesso',
}
</script>
<style scoped>
iframe {
    overflow: hidden;
}
</style>